// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CandidateDetail {
  flex: 1 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  overflow: auto;
  position: relative;
  padding-top: 0.75rem;
}
.CandidateDetail .LoaderContainer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1019607843);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.CandidateDetail .Back {
  position: absolute;
  top: 0rem;
  left: 0.75rem;
  height: 1.5rem;
  padding: 0 0.5rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: var(--AccentColor);
  background: var(--Background);
  z-index: 1;
  cursor: pointer;
}
.CandidateDetail .Back svg path {
  fill: var(--AccentColor);
}
.CandidateDetail .DetailsNavigation {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.625rem 2rem 0.625rem;
  border-radius: 0.625rem;
  border: 0.0625rem solid var(--Stroke);
  background: rgba(255, 255, 255, 0.05);
  position: relative;
}
.CandidateDetail .DetailsNavigation .DetailsSection {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 7.5rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .Name {
  font-size: 1.25rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: var(--TextColor);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .Status {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  text-transform: capitalize;
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .invitation {
  background: var(--Invitation);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .re-initiated {
  background: var(--Reinitiated);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .accepted {
  background: var(--Accepted);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .inprogress {
  background: var(--Inprogress);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .pending {
  background: var(--Pending);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .completed {
  background: var(--Completed);
}
.CandidateDetail .DetailsNavigation .DetailsSection .NameStatus .CurrentStatus .cancelled {
  background: var(--Cancelled);
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details {
  width: 65%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18.75rem, 1fr));
  gap: 0.625rem 1.25rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  color: var(--TextColor);
  font-size: 0.75rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Label {
  display: inherit;
  flex-direction: inherit;
  align-items: inherit;
  gap: 0.5rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Label span {
  font-weight: 600;
  white-space: nowrap;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .SubmitJobseekerId {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .SubmitJobseekerId div {
  position: relative;
  width: calc(100% - 5rem);
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .SubmitJobseekerId div input {
  width: 100%;
  height: 1.5rem;
  padding: 0.125rem 1rem 0.125rem 0.25rem;
  background: none;
  font-size: 0.75rem;
  border: none;
  border-bottom: 0.0625rem solid #9B9B9B;
  border-radius: none;
  position: relative;
  color: var(--TextColor);
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .SubmitJobseekerId div svg {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .SubmitJobseekerId div svg path {
  fill: var(--TextColor);
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .SubmitJobseekerId button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 4.5rem;
  height: 1.5rem;
  font-size: 0.75rem;
  background: var(--AccentColor);
  color: #ffffff;
  border-radius: 0.25rem;
  border: 0.0625rem solid rgba(155, 155, 155, 0.3019607843);
  transition: all 0.3s ease;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .JobseekerId {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 1rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .JobseekerId span {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .JobseekerId button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 5rem;
  height: 1.5rem;
  font-size: 0.75rem;
  color: var(--AccentColor);
  border-radius: 0.25rem;
  border: 0.0625rem solid rgba(155, 155, 155, 0.3019607843);
  transition: all 0.3s ease;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .JobseekerId button:hover {
  background: var(--Hover);
  transition: all 0.3s ease;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .Requested {
  border: 0.125rem dashed var(--Stroke);
  padding: 0 0.5rem;
  border-radius: 0.5rem;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .Requested span {
  color: #9B9B9B;
  cursor: default;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .Requested button {
  pointer-events: none;
  border: none;
  color: #9B9B9B;
}
.CandidateDetail .DetailsNavigation .DetailsSection .Details .LabelValue .Value .Requested button svg path {
  fill: #9B9B9B;
}
.CandidateDetail .DetailsNavigation .Navigation {
  position: absolute;
  top: calc(100% - 1.375rem);
  max-width: 90%;
  padding: 0.5rem;
  border-radius: 1.5rem;
  background: var(--Foreground);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.625rem;
  align-items: center;
  justify-content: space-between;
  border: 0.0625rem solid var(--Stroke);
}
.CandidateDetail .DetailsNavigation .Navigation .Nav {
  font-size: 0.75rem;
  line-height: 100%;
  color: var(--TextColor);
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  min-width: 6.25rem;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .DetailsNavigation .Navigation .Nav:hover:not(.Active) {
  background: var(--Invitation);
  color: var(--TextColor);
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .DetailsNavigation .Navigation .Active {
  background: var(--AccentColor);
  color: var(--Foreground);
  transition: all 0.2s ease-in-out;
}
.CandidateDetail .CheckDetails {
  flex: 1 1;
  width: 100%;
  overflow: auto;
}
.CandidateDetail .CheckDetails .DetailHeader {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--TextColor);
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.CandidateDetail .CheckDetails .DetailHeader svg {
  min-width: 1.5rem;
  cursor: pointer;
}
.CandidateDetail .CheckDetails .DetailHeader svg path {
  fill: var(--AccentColor);
}
.CandidateDetail .CheckDetails .DetailHeader h1 {
  cursor: pointer;
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0.25rem;
  height: 2.25rem;
  width: auto;
  background: var(--Foreground);
  border-radius: 1.25rem;
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle .Toggle {
  position: absolute;
  height: 1.75rem;
  width: 7.5rem;
  border-radius: 1rem;
  background: var(--Invitation);
  right: 0.25rem;
  transition: all 0.3s ease;
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle .Left {
  right: 5.9375rem;
  transition: all 0.3s ease;
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle *:not(.Toggle) {
  z-index: 1;
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle span {
  font-size: 0.75rem;
  color: #9B9B9B;
  cursor: pointer;
  width: 6rem;
  text-align: center;
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle .Active {
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle .ToggleIcon {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--AccentColor);
}
.CandidateDetail .CheckDetails .DetailHeader .CvToggle .ToggleIcon svg path {
  fill: #ffffff;
}
.CandidateDetail .CheckDetails .CandidateHistory {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 0.75rem;
  overflow: auto;
  position: relative;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader {
  position: sticky;
  top: 0;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader,
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 0.75rem 0.5rem;
  background: var(--Foreground);
  border-bottom: 0.0625rem solid var(--Stroke);
  border-radius: 0.75rem 0.75rem 0 0;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader span,
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow span {
  color: var(--TextColor);
  font-size: 0.875rem;
  font-weight: 700;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader span:nth-child(2),
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow span:nth-child(2) {
  flex: 1 1;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader span:nth-child(3),
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow span:nth-child(3) {
  width: 6rem;
  text-transform: capitalize;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader span:last-child,
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow span:last-child {
  width: 7rem;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader .Download,
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow .Download {
  width: 7rem;
  text-align: center;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableHeader .Download:is(a),
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow .Download:is(a) {
  width: 7rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  background: var(--AccentColor);
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow {
  border-radius: 0;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow span {
  font-weight: 400;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .TableRow:last-child {
  border-radius: 0 0 0.75rem 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateHistory .ContentCont .Hint {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
  padding-left: 1.75rem;
}
.CandidateDetail .CheckDetails .CandidateReportOverall {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateReportOverall .TabCont {
  border-bottom: 0.0625rem solid var(--Stroke);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateReportOverall .TabCont .Tab {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateReportOverall .TabCont .Tab span {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--TextColor);
  white-space: nowrap;
  height: 1.75rem;
  padding: 0 0.75rem;
  cursor: pointer;
}
.CandidateDetail .CheckDetails .CandidateReportOverall .TabCont .Tab .Active {
  font-weight: 700;
  border-bottom: 0.25rem solid var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateReportOverall .TabCont a {
  text-decoration: none;
  font-size: 0.875rem;
  color: var(--AccentColor);
  padding: 0 0.75rem;
  font-weight: 500;
}
.CandidateDetail .CheckDetails .CandidateReportOverall .ContentCont {
  flex: 1 1;
  overflow: auto;
  display: flex;
  justify-content: center;
}
.CandidateDetail .CheckDetails .CandidateReportOverall .ContentCont .pdfViewer {
  width: 60%;
  max-width: 60rem;
  height: 100%;
}
.CandidateDetail .CheckDetails .CandidateRequests {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateRequests .TabCont {
  border-bottom: 0.0625rem solid var(--Stroke);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateRequests .TabCont .Tab {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateRequests .TabCont .Tab span {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--TextColor);
  white-space: nowrap;
  height: 1.75rem;
  width: 10rem;
  cursor: pointer;
  text-align: center;
}
.CandidateDetail .CheckDetails .CandidateRequests .TabCont .Tab .Active {
  font-weight: 700;
  border-bottom: 0.25rem solid var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateRequests .ContentCont {
  flex: 1 1;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateApplicantData {
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 0.5rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper {
  height: 100%;
  padding: 2rem 0;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status .Title {
  color: var(--TextColor);
  font-size: 0.875rem;
  font-weight: 700;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status .Icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--Invitation);
  border: 0.0625rem solid var(--Invitation);
  width: 2rem;
  height: 2rem;
  transform: translateX(1rem);
  transition: all 0.3s ease-in-out;
  position: relative;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status .Icon svg {
  width: 1rem;
  height: 1rem;
  z-index: 1;
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status .Icon svg path {
  fill: var(--TextColor);
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status .Icon::before {
  position: absolute;
  content: "";
  height: 1.75rem;
  width: 1.75rem;
  border-radius: 50%;
  background: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Status:hover .Title {
  color: var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Active {
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Active .Title {
  color: var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Active .Icon {
  transform: translateX(1.5rem);
  border: 0.0625rem solid var(--AccentColor);
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Active .Icon svg {
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Active .Icon svg path {
  fill: #ffffff;
  transition: all 0.3s ease-in-out;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Active .Icon::before {
  background: var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Indicator {
  position: absolute;
  right: -2rem;
  height: 3rem;
  width: 3rem;
  background: var(--Background);
  border-radius: 0 50% 50% 0;
  transition: all 0.3s cubic-bezier(0, 1.55, 0.45, 0.85);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Indicator:after {
  display: block;
  content: "";
  width: 2rem;
  height: 1rem;
  border-bottom-left-radius: 1rem;
  background: transparent;
  position: absolute;
  top: -1rem;
  right: 2rem;
  transform: translateX(100%);
  box-shadow: -1rem 0 0 0 var(--Background);
  transition: all 0.3s cubic-bezier(0, 1.55, 0.45, 0.85);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .StatusBarWrapper .StatusBar .Indicator:before {
  display: block;
  content: "";
  width: 2rem;
  height: 1rem;
  border-top-left-radius: 1rem;
  background: transparent;
  position: absolute;
  bottom: -1rem;
  right: 2rem;
  transform: translateX(100%);
  box-shadow: -1rem 0 0 0 var(--Background);
  transition: all 0.3s cubic-bezier(0, 1.55, 0.45, 0.85);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData {
  flex: 1 1;
  background: var(--Foreground);
  border-radius: 0.75rem;
  padding: 0.75rem 0.75rem 0.75rem 3rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Header {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information {
  flex: 1 1;
  width: 100%;
  padding-left: 1rem;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .DetailsContainer {
  width: calc(100% - 1rem);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .DetailsContainer .LabelValue {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .DetailsContainer .LabelValue .Label {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .DetailsContainer .LabelValue .Value {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
  padding: 0.25rem;
  height: 2rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .Documents {
  width: calc(100% - 1rem);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .Documents .Title {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .Documents .IdContainer {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .Documents .IdContainer .DocumentCont {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: hidden;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .Documents .IdContainer .DocumentCont img {
  width: 100%;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .PersonalInformation .Documents .IdContainer .DocumentCont .pdfViewer {
  width: 100%;
  overflow: hidden;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .addressPreviewDiv {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .addressPreviewDiv .Documents {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .addressPreviewDiv .Documents .imgPrev {
  width: calc(100% - 2.5rem);
  padding: 1.25rem;
  height: 100%;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .addressPreviewDiv .Documents .imgPrev p {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  color: var(--TextColor);
  text-align: center;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .addressPreviewDiv .Documents .imgPrev img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation h1 {
  font-size: 1rem;
  font-weight: 700;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .Details {
  width: calc(100% - 1rem);
  padding-left: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .Details .LabelValue {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .Details .LabelValue .Label {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .ResidenceInformation .Details .LabelValue .Value {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
  padding: 0.25rem;
  height: 2rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .SignatureInformation {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .SignatureInformation span {
  font-size: 0.875rem;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .SignatureInformation img {
  width: 15rem;
  object-fit: cover;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education {
  width: calc(100% - 1rem);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduHeader {
  font-size: 1rem;
  font-weight: 700;
  color: var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent h3 {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .DetailsContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 1rem;
  padding-left: 1rem;
  margin-bottom: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .DetailsContainer .LabelValue {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .DetailsContainer .LabelValue .Label {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .DetailsContainer .LabelValue .Value {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
  padding: 0.25rem;
  height: 2rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .RadioOption {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding-left: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .RadioOption .No {
  color: #FB4848;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .RadioOption .Yes {
  color: #4DCC00;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .RadioOption span {
  color: var(--TextColor);
  font-size: 0.875rem;
  line-height: 0.875rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .RadioOption div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding-right: 2.5rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .RadioOption div span {
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .Document {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 1rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .Document.documentPrev {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 0.625rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .Document .imgPreviewer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .Document .imgPreviewer img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .EducationInformation .Education .EduContent .Document .imgPreviewer p {
  font-size: 0.875rem;
  color: var(--TextColor);
  font-weight: 600;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation {
  width: 100%;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content {
  width: calc(100% - 1rem);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  gap: 1.25rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content .IDCheck {
  width: 100%;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content .IDCheck h3 {
  font-size: 1rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--AccentColor);
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content .IDCheck span {
  color: #818181;
  font-size: 0.875rem;
  padding-left: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content .IDCheck .IDCheckContainer {
  width: 100%;
  max-height: 10rem;
  position: relative;
  border-radius: 0.25rem;
  overflow: hidden;
}
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content .IDCheck .IDCheckContainer iframe,
.CandidateDetail .CheckDetails .CandidateApplicantData .ApplicantData .Information .IdInformation .Content .IDCheck .IDCheckContainer img {
  width: 100%;
  border: none;
  display: block;
  overflow-y: hidden;
  background: none;
}
.CandidateDetail .CheckDetails .CandidateReportSummary {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 0.75rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check {
  width: calc(100% - 0.5rem);
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  background: var(--Foreground);
  border-radius: 0.5rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details span {
  font-size: 0.875rem;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .Name {
  padding-left: 1rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .UpgradeMain {
  flex: 1 1;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .UpgradeMain .UpgradeButton {
  font-size: 0.75rem;
  width: 5rem;
  background: var(--AccentColor);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.313rem;
  padding: 0.313rem;
  gap: 0.5rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .Status {
  font-size: 0.75rem;
  width: 7rem;
  min-height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--Background);
  border-radius: 0.25rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .Cancel {
  height: 1.75rem;
  width: 1.75rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .Cancel div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--Background);
  border-radius: 0.25rem;
  cursor: pointer;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .Cancel div svg path {
  fill: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .Details .Cancel .NotAllowed {
  opacity: 0.2;
  cursor: not-allowed;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails {
  margin-top: 0.5rem;
  border-top: 0.0625rem solid var(--Stroke);
  padding-top: 0.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus {
  border: 0.0625rem solid var(--Stroke);
  padding: 0.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .LabelName {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: hidden;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .LabelName span {
  color: var(--TextColor);
  font-size: 0.75rem;
  font-weight: 400;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .LabelName span:nth-child(2) {
  font-size: 0.875rem;
  font-weight: 500;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .Status {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background: var(--Background);
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .Success,
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .success {
  background: var(--Completed);
  text-transform: capitalize;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .Failed,
.CandidateDetail .CheckDetails .CandidateReportSummary .ContentCont .Check .SubDetails .NameStatus .failed {
  background: var(--Cancelled);
  text-transform: capitalize;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(105, 105, 105, 0.1098039216);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal {
  background: var(--Foreground);
  padding: 2rem 2rem 1rem 2rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 35rem;
  max-height: 90%;
  overflow: auto;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .Header {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .Hint {
  width: 100%;
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--TextColor);
  text-wrap: balance;
  text-align: center;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .DropZone {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
  width: 100%;
  border: 0.125rem dashed var(--Stroke);
  border-radius: 0.5rem;
  padding: 1rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .DropZone .Upload {
  display: flex;
  gap: 0.25rem;
  font-size: 0.875rem;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .DropZone .Upload label {
  color: var(--AccentColor);
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .DropZone .Upload label input {
  display: none;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .DraggingOver {
  opacity: 0.5;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal textarea {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.5rem;
  height: 5rem;
  border: 0.0625rem solid var(--Stroke);
  background: none;
  resize: none;
  font-size: 0.875rem;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .ButtonCont {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .ButtonCont button {
  width: 6rem;
  height: 2.25rem;
  background: var(--Background);
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: var(--TextColor);
}
.CandidateDetail .CheckDetails .CandidateReportSummary .ModalContainer .Modal .ButtonCont .Proceed {
  background: var(--AccentColor);
  color: #ffffff;
}
.CandidateDetail .UpdateToolTip {
  position: fixed;
  display: flex;
  align-items: center;
  height: 6rem;
  width: 24rem;
  background: var(--Foreground);
  border-radius: 0.5rem;
  box-shadow: 0.125rem 0.125rem 0.5rem var(--Invitation);
  border: 0.0625rem solid var(--AccentColor);
}
.CandidateDetail .UpdateToolTip img {
  height: 100%;
  aspect-ratio: 1/1;
  padding: 0.25rem;
  border-radius: 0.5rem;
}
.CandidateDetail .UpdateToolTip div {
  width: calc(100% - 5rem);
  display: flex;
  flex-direction: column;
}
.CandidateDetail .UpdateToolTip div h3 {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--TextColor);
}
.CandidateDetail .UpdateToolTip div p,
.CandidateDetail .UpdateToolTip div li {
  color: var(--TextColor);
  font-size: 0.625rem;
}
.CandidateDetail .UpdateToolTip div li {
  margin-left: 0.5rem;
  width: calc(100% - 1rem);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.CandidateDetail .UpdateToolTip::after, .CandidateDetail .UpdateToolTip::before {
  content: "";
  width: 0.875rem;
  height: 0.5rem;
  clip-path: polygon(100% 0, 0 0, 50% 100%);
  position: absolute;
  background: var(--Foreground);
  display: block;
  bottom: -0.5rem;
  right: 0.75rem;
}
.CandidateDetail .UpdateToolTip::before {
  width: 1rem;
  height: 0.625rem;
  background: var(--AccentColor);
  bottom: -0.625rem;
  right: 0.6875rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/CandidateDetails/CandidateDetail.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;AAEE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;AAAJ;AAGM;EACE,wBAAA;AADR;AAME;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qCAAA;EACA,qCAAA;EACA,kBAAA;AAJJ;AAMI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAJN;AAMM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAJR;AAMQ;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJV;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AALV;AAOU;EACE,uBAAA;EACA,sBAAA;EACA,0BAAA;AALZ;AAQU;EACE,6BAAA;AANZ;AASU;EACE,8BAAA;AAPZ;AAUU;EACE,2BAAA;AARZ;AAWU;EACE,6BAAA;AATZ;AAYU;EACE,0BAAA;AAVZ;AAaU;EACE,4BAAA;AAXZ;AAcU;EACE,4BAAA;AAZZ;AAiBM;EACE,UAAA;EACA,aAAA;EACA,+DAAA;EACA,qBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAfV;AAiBU;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;AAfZ;AAiBY;EACE,gBAAA;EACA,mBAAA;AAfd;AAmBU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBZ;AAmBY;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAjBd;AAmBc;EACE,kBAAA;EACA,wBAAA;AAjBhB;AAmBgB;EACE,WAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAjBlB;AAoBgB;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AAlBlB;AAoBkB;EACE,sBAAA;AAlBpB;AAuBc;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;EACA,sBAAA;EACA,yDAAA;EACA,yBAAA;AArBhB;AAyBY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAvBd;AAyBc;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvBhB;AA0Bc;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yDAAA;EACA,yBAAA;AAxBhB;AA2Bc;EACE,wBAAA;EACA,yBAAA;AAzBhB;AA6BY;EACE,qCAAA;EACA,iBAAA;EACA,qBAAA;AA3Bd;AA6Bc;EACE,cAAA;EACA,eAAA;AA3BhB;AA8Bc;EACE,oBAAA;EACA,YAAA;EACA,cAAA;AA5BhB;AA+BkB;EACE,aAAA;AA7BpB;AAuCI;EACE,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;AArCN;AAuCM;EACE,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AArCR;AAwCM;EACE,6BAAA;EACA,uBAAA;EACA,gCAAA;AAtCR;AAyCM;EACE,8BAAA;EACA,wBAAA;EACA,gCAAA;AAvCR;AA4CE;EACE,SAAA;EACA,WAAA;EACA,cAAA;AA1CJ;AA4CI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA1CN;AA4CM;EACE,iBAAA;EACA,eAAA;AA1CR;AA4CQ;EACE,wBAAA;AA1CV;AA8CM;EACE,eAAA;AA5CR;AA+CM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,sBAAA;AA7CR;AA+CQ;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;AA7CV;AAgDQ;EACE,gBAAA;EACA,yBAAA;AA9CV;AAiDQ;EACE,UAAA;AA/CV;AAkDQ;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAhDV;AAmDQ;EACE,uBAAA;AAjDV;AAoDQ;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AAlDV;AAqDY;EACE,aAAA;AAnDd;AA0DI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAxDN;AA0DM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAxDR;AA0DQ;EACE,gBAAA;EACA,MAAA;AAxDV;AA2DQ;;EAEE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,4CAAA;EACA,kCAAA;AAzDV;AA2DU;;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAxDZ;AA2DU;;EACE,SAAA;AAxDZ;AA2DU;;EACE,WAAA;EACA,0BAAA;AAxDZ;AA2DU;;EACE,WAAA;AAxDZ;AA2DU;;EACE,WAAA;EACA,kBAAA;AAxDZ;AA2DU;;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;AAxDZ;AA4DQ;EACE,gBAAA;AA1DV;AA4DU;EACE,gBAAA;AA1DZ;AA8DQ;EACE,kCAAA;AA5DV;AA+DQ;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AA7DV;AAkEI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAhEN;AAkEM;EACE,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAhER;AAkEQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhEV;AAkEU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAhEZ;AAmEU;EACE,gBAAA;EACA,+CAAA;AAjEZ;AAqEQ;EACE,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnEV;AAuEM;EACE,SAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;AArER;AAuEQ;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AArEV;AA0EI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAxEN;AA0EM;EACE,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAxER;AA0EQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxEV;AA0EU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAxEZ;AA2EU;EACE,gBAAA;EACA,+CAAA;AAzEZ;AA8EM;EACE,SAAA;EACA,cAAA;AA5ER;AAgFI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AA9EN;AAgFM;EACE,YAAA;EACA,eAAA;AA9ER;AAgFQ;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AA9EV;AAgFU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,eAAA;EACA,gCAAA;AA9EZ;AAgFY;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AA9Ed;AAiFY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;AA/Ed;AAiFc;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;AA/EhB;AAiFgB;EACE,sBAAA;EACA,gCAAA;AA/ElB;AAoFY;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gCAAA;AAlFd;AAuFY;EACE,yBAAA;AArFd;AAyFU;EACE,gCAAA;AAvFZ;AAyFY;EACE,yBAAA;AAvFd;AA0FY;EACE,6BAAA;EACA,0CAAA;EACA,gCAAA;AAxFd;AA0Fc;EACE,gCAAA;AAxFhB;AA0FgB;EACE,aAAA;EACA,gCAAA;AAxFlB;AA6FY;EACE,8BAAA;AA3Fd;AA+FU;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,0BAAA;EACA,sDAAA;AA7FZ;AAgGU;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,yCAAA;EACA,sDAAA;AA9FZ;AAiGU;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,2BAAA;EACA,yCAAA;EACA,sDAAA;AA/FZ;AAoGM;EACE,SAAA;EACA,6BAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlGR;AAoGQ;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;AAlGV;AAqGQ;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAnGV;AAqGU;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAnGZ;AAqGY;EACE,wBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AAnGd;AAqGc;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAnGhB;AAqGgB;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AAnGlB;AAsGgB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AApGlB;AAyGY;EACE,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAvGd;AAyGc;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvGhB;AA0Gc;EACE,WAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AAxGhB;AA0GgB;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAxGlB;AA0GkB;EACE,WAAA;AAxGpB;AA2GkB;EACE,WAAA;EACA,gBAAA;AAzGpB;AAgHU;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA9GZ;AAgHY;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA9Gd;AAgHc;EACE,WAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AA9GhB;AAgHgB;EACE,0BAAA;EACA,gBAAA;EAEA,YAAA;AA/GlB;AAiHkB;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA/GpB;AAkHkB;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAhHpB;AAsHY;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AApHd;AAuHY;EACE,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;EACA,mBAAA;AArHd;AAuHc;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AArHhB;AAuHgB;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AArHlB;AAwHgB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;AAtHlB;AA4HU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1HZ;AA4HY;EACE,mBAAA;EACA,uBAAA;AA1Hd;AA6HY;EACE,YAAA;EACA,iBAAA;AA3Hd;AA+HU;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA7HZ;AA+HY;EACE,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA7Hd;AA+Hc;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AA7HhB;AAgIc;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA9HhB;AAgIgB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9HlB;AAiIgB;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AA/HlB;AAiIkB;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AA/HpB;AAiIoB;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AA/HtB;AAkIoB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AAhItB;AAqIgB;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAnIlB;AAqIkB;EACE,cAAA;AAnIpB;AAsIkB;EACE,cAAA;AApIpB;AAuIkB;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;AArIpB;AAwIkB;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAtIpB;AAwIoB;EACE,uBAAA;AAtItB;AA2IgB;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAzIlB;AA2IkB;EACE,aAAA;EACA,4DAAA;EACA,aAAA;AAzIpB;AA4IkB;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1IpB;AA4IoB;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AA1ItB;AA6IoB;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;AA3ItB;AA+KU;EACE,WAAA;AA7KZ;AA+KY;EACE,wBAAA;EACA,aAAA;EACA,4DAAA;EACA,YAAA;AA7Kd;AA+Kc;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qCAAA;EACA,sBAAA;AA7KhB;AA+KgB;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AA7KlB;AAgLgB;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9KlB;AAiLgB;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AA/KlB;AAiLkB;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA/KpB;AAyLI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAvLN;AAyLM;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAvLR;AAyLQ;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;AAvLV;AAyLU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAvLZ;AAyLY;EACE,mBAAA;EACA,uBAAA;AAvLd;AAyLY;EAEE,kBAAA;AAxLd;AA0LY;EACE,SAAA;AAxLd;AAyLc;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AAvLhB;AA+LY;EAEE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;AA9Ld;AAiMY;EACE,eAAA;EACA,cAAA;AA/Ld;AAiMc;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AA/LhB;AAkMkB;EACE,sBAAA;AAhMpB;AAqMc;EACE,YAAA;EACA,mBAAA;AAnMhB;AAwMU;EACE,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AAtMZ;AAwMY;EACE,qCAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAtMd;AAwMc;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAtMhB;AAwMgB;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;AAtMlB;AAyMgB;EACE,mBAAA;EACA,gBAAA;AAvMlB;AA2Mc;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;AAzMhB;AA4Mc;;EAEE,4BAAA;EACA,0BAAA;AA1MhB;AA6Mc;;EAEE,4BAAA;EACA,0BAAA;AA3MhB;AAkNM;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,6CAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAhNR;AAkNQ;EACE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAhNV;AAkNU;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;AAhNZ;AAmNU;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAjNZ;AAoNU;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,qCAAA;EACA,qBAAA;EACA,aAAA;AAlNZ;AAoNY;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAlNd;AAoNc;EACE,yBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAlNhB;AAoNgB;EACE,aAAA;AAlNlB;AAwNU;EACE,YAAA;AAtNZ;AAyNU;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAvNZ;AA0NU;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAxNZ;AA0NY;EACE,WAAA;EACA,eAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAxNd;AA2NY;EACE,8BAAA;EACA,cAAA;AAzNd;AAkOE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,sDAAA;EACA,0CAAA;AAhOJ;AAkOI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAhON;AAmOI;EACE,wBAAA;EACA,aAAA;EACA,sBAAA;AAjON;AAmOM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjOR;AAoOM;;EAEE,uBAAA;EACA,mBAAA;AAlOR;AAqOM;EACE,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAnOR;AAuOI;EAEE,WAAA;EACA,eAAA;EACA,cAAA;EACA,yCAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EAEA,eAAA;EACA,cAAA;AAvON;AA0OI;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AAxON","sourcesContent":[".CandidateDetail {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  overflow: auto;\n  position: relative;\n  padding-top: 0.75rem;\n\n  .LoaderContainer {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: #0000001a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n  }\n\n  .Back {\n    position: absolute;\n    top: 0rem;\n    left: 0.75rem;\n    height: 1.5rem;\n    padding: 0 0.5rem;\n    border-radius: 0.375rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.25rem;\n    font-size: 0.75rem;\n    color: var(--AccentColor);\n    background: var(--Background);\n    z-index: 1;\n    cursor: pointer;\n\n    svg {\n      path {\n        fill: var(--AccentColor);\n      }\n    }\n  }\n\n  .DetailsNavigation {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1rem 0.625rem 2rem 0.625rem;\n    border-radius: 0.625rem;\n    border: 0.0625rem solid var(--Stroke);\n    background: rgba(255, 255, 255, 0.05);\n    position: relative;\n\n    .DetailsSection {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n\n      .NameStatus {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n        min-width: 7.5rem;\n\n        .Name {\n          font-size: 1.25rem;\n          color: var(--TextColor);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .CurrentStatus {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 0.5rem;\n          font-size: 0.75rem;\n          color: var(--TextColor);\n\n          .Status {\n            padding: 0.25rem 0.5rem;\n            border-radius: 0.25rem;\n            text-transform: capitalize;\n          }\n\n          .invitation {\n            background: var(--Invitation);\n          }\n\n          .re-initiated {\n            background: var(--Reinitiated);\n          }\n\n          .accepted {\n            background: var(--Accepted);\n          }\n\n          .inprogress {\n            background: var(--Inprogress);\n          }\n\n          .pending {\n            background: var(--Pending);\n          }\n\n          .completed {\n            background: var(--Completed);\n          }\n\n          .cancelled {\n            background: var(--Cancelled);\n          }\n        }\n      }\n\n      .Details {\n        width: 65%;\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(18.75rem, 1fr));\n        gap: 0.625rem 1.25rem;\n\n        .LabelValue {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 0.75rem;\n          color: var(--TextColor);\n          font-size: 0.75rem;\n\n          .Label {\n            display: inherit;\n            flex-direction: inherit;\n            align-items: inherit;\n            gap: 0.5rem;\n\n            span {\n              font-weight: 600;\n              white-space: nowrap;\n            }\n          }\n\n          .Value {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n\n            .SubmitJobseekerId {\n              width: 100%;\n              display: flex;\n              align-items: center;\n              gap: 1rem;\n\n              div {\n                position: relative;\n                width: calc(100% - 5rem);\n\n                input {\n                  width: 100%;\n                  height: 1.5rem;\n                  padding: 0.125rem 1rem 0.125rem 0.25rem;\n                  background: none;\n                  font-size: 0.75rem;\n                  border: none;\n                  border-bottom: 0.0625rem solid #9B9B9B;\n                  border-radius: none;\n                  position: relative;\n                  color: var(--TextColor);\n                }\n\n                svg {\n                  position: absolute;\n                  right: 0;\n                  top: 50%;\n                  transform: translateY(-50%);\n                  cursor: pointer;\n\n                  path {\n                    fill: var(--TextColor);\n                  }\n                }\n              }\n\n              button {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                min-width: 4.5rem;\n                height: 1.5rem;\n                font-size: 0.75rem;\n                background: var(--AccentColor);\n                color: #ffffff;\n                border-radius: 0.25rem;\n                border: 0.0625rem solid #9b9b9b4d;\n                transition: all 0.3s ease;\n              }\n            }\n\n            .JobseekerId {\n              display: flex;\n              align-items: center;\n              gap: 0.5rem;\n              margin-right: 1rem;\n\n              span {\n                flex: 1;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n\n              button {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 0.25rem;\n                width: 5rem;\n                height: 1.5rem;\n                font-size: 0.75rem;\n                color: var(--AccentColor);\n                border-radius: 0.25rem;\n                border: 0.0625rem solid #9b9b9b4d;\n                transition: all 0.3s ease;\n              }\n\n              button:hover {\n                background: var(--Hover);\n                transition: all 0.3s ease;\n              }\n            }\n\n            .Requested {\n              border: 0.125rem dashed var(--Stroke);\n              padding: 0 0.5rem;\n              border-radius: 0.5rem;\n\n              span {\n                color: #9B9B9B;\n                cursor: default;\n              }\n\n              button {\n                pointer-events: none;\n                border: none;\n                color: #9B9B9B;\n\n                svg {\n                  path {\n                    fill: #9B9B9B;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .Navigation {\n      position: absolute;\n      top: calc(100% - 1.375rem);\n      max-width: 90%;\n      padding: 0.5rem;\n      border-radius: 1.5rem;\n      background: var(--Foreground);\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      gap: 0.625rem;\n      align-items: center;\n      justify-content: space-between;\n      border: 0.0625rem solid var(--Stroke);\n\n      .Nav {\n        font-size: 0.75rem;\n        line-height: 100%;\n        color: var(--TextColor);\n        padding: 0.5rem 0.75rem;\n        border-radius: 1rem;\n        min-width: 6.25rem;\n        cursor: pointer;\n        text-align: center;\n        white-space: nowrap;\n        transition: all 0.3s ease-in-out;\n      }\n\n      .Nav:hover:not(.Active) {\n        background: var(--Invitation);\n        color: var(--TextColor);\n        transition: all 0.3s ease-in-out;\n      }\n\n      .Active {\n        background: var(--AccentColor);\n        color: var(--Foreground);\n        transition: all 0.2s ease-in-out;\n      }\n    }\n  }\n\n  .CheckDetails {\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n\n    .DetailHeader {\n      font-size: 1.125rem;\n      font-weight: 700;\n      color: var(--TextColor);\n      display: flex;\n      align-items: center;\n      gap: 0.25rem;\n\n      svg {\n        min-width: 1.5rem;\n        cursor: pointer;\n\n        path {\n          fill: var(--AccentColor);\n        }\n      }\n\n      h1 {\n        cursor: pointer;\n      }\n\n      .CvToggle {\n        display: flex;\n        align-items: center;\n        position: relative;\n        padding: 0.25rem;\n        height: 2.25rem;\n        width: auto;\n        background: var(--Foreground);\n        border-radius: 1.25rem;\n\n        .Toggle {\n          position: absolute;\n          height: 1.75rem;\n          width: 7.5rem;\n          border-radius: 1rem;\n          background: var(--Invitation);\n          right: 0.25rem;\n          transition: all 0.3s ease;\n        }\n\n        .Left {\n          right: 5.9375rem;\n          transition: all 0.3s ease;\n        }\n\n        & *:not(.Toggle) {\n          z-index: 1;\n        }\n\n        span {\n          font-size: 0.75rem;\n          color: #9B9B9B;\n          cursor: pointer;\n          width: 6rem;\n          text-align: center;\n        }\n\n        .Active {\n          color: var(--TextColor);\n        }\n\n        .ToggleIcon {\n          width: 1.25rem;\n          height: 1.25rem;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: var(--AccentColor);\n\n          svg {\n            path {\n              fill: #ffffff;\n            }\n          }\n        }\n      }\n    }\n\n    .CandidateHistory {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      overflow: auto;\n\n      .ContentCont {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        border-radius: 0.75rem;\n        overflow: auto;\n        position: relative;\n\n        .TableHeader {\n          position: sticky;\n          top: 0;\n        }\n\n        .TableHeader,\n        .TableRow {\n          width: 100%;\n          display: flex;\n          align-items: center;\n          gap: 1.5rem;\n          padding: 0.75rem 0.5rem;\n          background: var(--Foreground);\n          border-bottom: 0.0625rem solid var(--Stroke);\n          border-radius: 0.75rem 0.75rem 0 0;\n\n          span {\n            color: var(--TextColor);\n            font-size: 0.875rem;\n            font-weight: 700;\n          }\n\n          span:nth-child(2) {\n            flex: 1;\n          }\n\n          span:nth-child(3) {\n            width: 6rem;\n            text-transform: capitalize;\n          }\n\n          span:last-child {\n            width: 7rem;\n          }\n\n          .Download {\n            width: 7rem;\n            text-align: center;\n          }\n\n          .Download:is(a) {\n            width: 7rem;\n            height: 2rem;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: #ffffff;\n            text-decoration: none;\n            background: var(--AccentColor);\n            border-radius: 0.25rem;\n            font-size: 0.875rem;\n          }\n        }\n\n        .TableRow {\n          border-radius: 0;\n\n          span {\n            font-weight: 400;\n          }\n        }\n\n        .TableRow:last-child {\n          border-radius: 0 0 0.75rem 0.75rem;\n        }\n\n        .Hint {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: var(--TextColor);\n          padding-left: 1.75rem;\n        }\n      }\n    }\n\n    .CandidateReportOverall {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      overflow: auto;\n\n      .TabCont {\n        border-bottom: 0.0625rem solid var(--Stroke);\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 1rem;\n\n        .Tab {\n          display: flex;\n          align-items: center;\n          gap: 1rem;\n\n          span {\n            font-size: 0.875rem;\n            font-weight: 400;\n            color: var(--TextColor);\n            white-space: nowrap;\n            height: 1.75rem;\n            padding: 0 0.75rem;\n            cursor: pointer;\n          }\n\n          .Active {\n            font-weight: 700;\n            border-bottom: 0.25rem solid var(--AccentColor);\n          }\n        }\n\n        a {\n          text-decoration: none;\n          font-size: 0.875rem;\n          color: var(--AccentColor);\n          padding: 0 0.75rem;\n          font-weight: 500;\n        }\n      }\n\n      .ContentCont {\n        flex: 1;\n        overflow: auto;\n        display: flex;\n        justify-content: center;\n\n        .pdfViewer {\n          width: 60%;\n          max-width: 60rem;\n          height: 100%;\n        }\n      }\n    }\n\n    .CandidateRequests {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      overflow: auto;\n\n      .TabCont {\n        border-bottom: 0.0625rem solid var(--Stroke);\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 1rem;\n\n        .Tab {\n          display: flex;\n          align-items: center;\n          gap: 1rem;\n\n          span {\n            font-size: 0.875rem;\n            font-weight: 400;\n            color: var(--TextColor);\n            white-space: nowrap;\n            height: 1.75rem;\n            width: 10rem;\n            cursor: pointer;\n            text-align: center;\n          }\n\n          .Active {\n            font-weight: 700;\n            border-bottom: 0.25rem solid var(--AccentColor);\n          }\n        }\n      }\n\n      .ContentCont {\n        flex: 1;\n        overflow: auto;\n      }\n    }\n\n    .CandidateApplicantData {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      padding-left: 0.5rem;\n\n      .StatusBarWrapper {\n        height: 100%;\n        padding: 2rem 0;\n\n        .StatusBar {\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n          position: relative;\n\n          .Status {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            z-index: 1;\n            cursor: pointer;\n            transition: all 0.3s ease-in-out;\n\n            .Title {\n              color: var(--TextColor);\n              font-size: 0.875rem;\n              font-weight: 700;\n            }\n\n            .Icon {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-radius: 50%;\n              background: var(--Invitation);\n              border: 0.0625rem solid var(--Invitation);\n              width: 2rem;\n              height: 2rem;\n              transform: translateX(1rem);\n              transition: all 0.3s ease-in-out;\n              position: relative;\n\n              svg {\n                width: 1rem;\n                height: 1rem;\n                z-index: 1;\n                transition: all 0.3s ease-in-out;\n\n                path {\n                  fill: var(--TextColor);\n                  transition: all 0.3s ease-in-out;\n                }\n              }\n            }\n\n            .Icon::before {\n              position: absolute;\n              content: '';\n              height: 1.75rem;\n              width: 1.75rem;\n              border-radius: 50%;\n              background: none;\n              top: 50%;\n              left: 50%;\n              transform: translate(-50%, -50%);\n              transition: all 0.3s ease-in-out;\n            }\n          }\n\n          .Status:hover {\n            .Title {\n              color: var(--AccentColor);\n            }\n          }\n\n          .Active {\n            transition: all 0.3s ease-in-out;\n\n            .Title {\n              color: var(--AccentColor);\n            }\n\n            .Icon {\n              transform: translateX(1.5rem);\n              border: 0.0625rem solid var(--AccentColor);\n              transition: all 0.3s ease-in-out;\n\n              svg {\n                transition: all 0.3s ease-in-out;\n\n                path {\n                  fill: #ffffff;\n                  transition: all 0.3s ease-in-out;\n                }\n              }\n            }\n\n            .Icon::before {\n              background: var(--AccentColor);\n            }\n          }\n\n          .Indicator {\n            position: absolute;\n            right: -2rem;\n            height: 3rem;\n            width: 3rem;\n            background: var(--Background);\n            border-radius: 0 50% 50% 0;\n            transition: all 0.3s cubic-bezier(0, 1.55, .45, .85);\n          }\n\n          .Indicator:after {\n            display: block;\n            content: '';\n            width: 2rem;\n            height: 1rem;\n            border-bottom-left-radius: 1rem;\n            background: transparent;\n            position: absolute;\n            top: -1rem;\n            right: 2rem;\n            transform: translateX(100%);\n            box-shadow: -1rem 0 0 0 var(--Background);\n            transition: all 0.3s cubic-bezier(0, 1.55, .45, .85);\n          }\n\n          .Indicator:before {\n            display: block;\n            content: '';\n            width: 2rem;\n            height: 1rem;\n            border-top-left-radius: 1rem;\n            background: transparent;\n            position: absolute;\n            bottom: -1rem;\n            right: 2rem;\n            transform: translateX(100%);\n            box-shadow: -1rem 0 0 0 var(--Background);\n            transition: all 0.3s cubic-bezier(0, 1.55, .45, .85);\n          }\n        }\n      }\n\n      .ApplicantData {\n        flex: 1;\n        background: var(--Foreground);\n        border-radius: 0.75rem;\n        padding: 0.75rem 0.75rem 0.75rem 3rem;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n\n        .Header {\n          font-size: 1.5rem;\n          font-weight: 700;\n          color: var(--TextColor);\n        }\n\n        .Information {\n          flex: 1;\n          width: 100%;\n          padding-left: 1rem;\n          overflow: auto;\n\n          .PersonalInformation {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 2rem;\n\n            .DetailsContainer {\n              width: calc(100% - 1rem);\n              display: grid;\n              grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));\n              gap: 1rem;\n\n              .LabelValue {\n                display: flex;\n                flex-direction: column;\n                gap: 0.125rem;\n\n                .Label {\n                  font-size: 0.75rem;\n                  font-weight: 400;\n                  color: var(--TextColor);\n                }\n\n                .Value {\n                  font-size: 0.875rem;\n                  font-weight: 500;\n                  color: var(--TextColor);\n                  padding: 0.25rem;\n                  height: 2rem;\n                  border: 0.0625rem solid var(--Stroke);\n                  border-radius: 0.25rem;\n                  display: flex;\n                  align-items: center;\n                }\n              }\n            }\n\n            .Documents {\n              width: calc(100% - 1rem);\n              display: flex;\n              flex-direction: column;\n              gap: 0.5rem;\n\n              .Title {\n                font-size: 0.875rem;\n                font-weight: 500;\n                color: var(--TextColor);\n              }\n\n              .IdContainer {\n                width: 100%;\n                display: grid;\n                grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n                gap: 1rem;\n\n                .DocumentCont {\n                  width: 100%;\n                  display: flex;\n                  flex-direction: column;\n                  gap: 0.5rem;\n                  overflow: hidden;\n\n                  img {\n                    width: 100%;\n                  }\n\n                  .pdfViewer {\n                    width: 100%;\n                    overflow: hidden;\n                  }\n                }\n              }\n            }\n          }\n\n          .ResidenceInformation {\n            width: 100%;\n            height: 100%;\n            overflow: auto;\n            display: flex;\n            flex-direction: column;\n            gap: 0.75rem;\n\n            .addressPreviewDiv {\n              display: flex;\n              flex-direction: column;\n              gap: .75rem;\n\n              .Documents {\n                width: 100%;\n                display: grid;\n                grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n                gap: 1rem;\n\n                .imgPrev {\n                  width: calc(100% - 2.5rem);\n                  padding: 1.25rem;\n                  // height: 30rem;\n                  height: 100%;\n\n                  p {\n                    width: 100%;\n                    height: 100%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    font-size: 1.125rem;\n                    color: var(--TextColor);\n                    text-align: center;\n                  }\n\n                  img {\n                    object-fit: contain;\n                    width: 100%;\n                    height: 100%;\n                  }\n                }\n              }\n            }\n\n            h1 {\n              font-size: 1rem;\n              font-weight: 700;\n              color: var(--TextColor);\n            }\n\n            .Details {\n              width: calc(100% - 1rem);\n              padding-left: 1rem;\n              display: grid;\n              grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));\n              gap: 1rem;\n              margin-bottom: 1rem;\n\n              .LabelValue {\n                display: flex;\n                flex-direction: column;\n                gap: 0.125rem;\n\n                .Label {\n                  font-size: 0.75rem;\n                  font-weight: 400;\n                  color: var(--TextColor);\n                }\n\n                .Value {\n                  font-size: 0.875rem;\n                  font-weight: 500;\n                  color: var(--TextColor);\n                  padding: 0.25rem;\n                  height: 2rem;\n                  border: 0.0625rem solid var(--Stroke);\n                  border-radius: 0.25rem;\n                  display: block;\n                  white-space: nowrap;\n                  overflow: hidden;                  \n                  text-overflow: ellipsis;\n                  width: 90%;                  \n                }\n              }\n            }\n          }\n\n          .SignatureInformation {\n            display: flex;\n            flex-direction: column;\n            gap: 1rem;\n\n            span {\n              font-size: 0.875rem;\n              color: var(--TextColor);\n            }\n\n            img {\n              width: 15rem;\n              object-fit: cover;\n            }\n          }\n\n          .EducationInformation {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 2rem;\n\n            .Education {\n              width: calc(100% - 1rem);\n              display: flex;\n              flex-direction: column;\n              gap: 0.75rem;\n\n              .EduHeader {\n                font-size: 1rem;\n                font-weight: 700;\n                color: var(--AccentColor);\n              }\n\n              .EduContent {\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: 0.75rem;\n\n                h3 {\n                  font-size: 0.875rem;\n                  font-weight: 700;\n                  color: var(--TextColor);\n                }\n\n                .DetailsContainer {\n                  display: grid;\n                  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));\n                  gap: 1rem;\n                  padding-left: 1rem;\n                  margin-bottom: 1rem;\n\n                  .LabelValue {\n                    display: flex;\n                    flex-direction: column;\n                    gap: 0.125rem;\n\n                    .Label {\n                      font-size: 0.75rem;\n                      font-weight: 400;\n                      color: var(--TextColor);\n                    }\n\n                    .Value {\n                      font-size: 0.875rem;\n                      font-weight: 500;\n                      color: var(--TextColor);\n                      padding: 0.25rem;\n                      height: 2rem;\n                      border: 0.0625rem solid var(--Stroke);\n                      border-radius: 0.25rem;\n                      display: flex;\n                      align-items: center;\n                    }\n                  }\n                }\n\n                .RadioOption {\n                  display: flex;\n                  flex-direction: row;\n                  align-items: center;\n                  gap: 0.75rem;\n                  padding-left: 1rem;\n\n                  .No {\n                    color: #FB4848;\n                  }\n\n                  .Yes {\n                    color: #4DCC00;\n                  }\n\n                  span {\n                    color: var(--TextColor);\n                    font-size: 0.875rem;\n                    line-height: 0.875rem;\n                  }\n\n                  div {\n                    display: flex;\n                    flex-direction: row;\n                    align-items: center;\n                    gap: 0.75rem;\n                    padding-right: 2.5rem;\n\n                    span {\n                      color: var(--TextColor);\n                    }\n                  }\n                }\n\n                .Document {\n                  display: flex;\n                  flex-direction: row;\n                  justify-content: flex-start;\n                  padding-left: 1rem;\n\n                  &.documentPrev {\n                    display: grid;\n                    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n                    gap: .625rem;\n                  }\n\n                  .imgPreviewer {\n                    width: 100%;\n                    height: 100%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n\n                    img {\n                      object-fit: contain;\n                      width: 100%;\n                      height: 100%;\n                    }\n\n                    p {\n                      font-size: .875rem;\n                      color: var(--TextColor);\n                      font-weight: 600;\n                    }\n                  }\n\n                  // label{\n                  //   padding: 0.5rem 1rem 0.5rem 0.5rem;\n                  //   display: flex;\n                  //   flex-direction: row;\n                  //   align-items: center;\n                  //   gap: 0.5rem;\n                  //   background: var(--Invitation);\n                  //   width: auto;\n                  //   border-radius: 0.5rem;\n                  //   max-width: 12.5rem;\n                  //   cursor: pointer;\n                  //   svg{\n                  //     min-width: 1rem;\n                  //     path{\n                  //       fill: var(--AccentColor);\n                  //     }\n                  //   }\n                  //   a{\n                  //     text-decoration: none;\n                  //     color: var(--TextColor);\n                  //     font-size: 0.875rem;\n                  //     font-weight: 400;\n                  //     white-space: nowrap;\n                  //     overflow: hidden;\n                  //     text-overflow: ellipsis;\n                  //   }\n                  // }\n                }\n              }\n            }\n          }\n\n          .IdInformation {\n            width: 100%;\n\n            .Content {\n              width: calc(100% - 1rem);\n              display: grid;\n              grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));\n              gap: 1.25rem;\n\n              .IDCheck {\n                width: 100%;\n                padding: 0.75rem;\n                display: flex;\n                flex-direction: column;\n                gap: 0.5rem;\n                border: 0.0625rem solid var(--Stroke);\n                border-radius: 0.75rem;\n\n                h3 {\n                  font-size: 1rem;\n                  font-weight: 700;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                  color: var(--AccentColor);\n                }\n\n                span {\n                  color: #818181;\n                  font-size: 0.875rem;\n                  padding-left: 0.5rem;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n\n                .IDCheckContainer {\n                  width: 100%;\n                  max-height: 10rem;\n                  position: relative;\n                  border-radius: 0.25rem;\n                  overflow: hidden;\n\n                  iframe,\n                  img {\n                    width: 100%;\n                    border: none;\n                    display: block;\n                    overflow-y: hidden;\n                    background: none;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .CandidateReportSummary {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      overflow: auto;\n\n      .ContentCont {\n        flex: 1;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        overflow: auto;\n        gap: 0.75rem;\n\n        .Check {\n          width: calc(100% - 0.5rem);\n          display: flex;\n          flex-direction: column;\n          padding: 0.75rem;\n          background: var(--Foreground);\n          border-radius: 0.5rem;\n\n          .Details {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n\n            span {\n              font-size: 0.875rem;\n              color: var(--TextColor);\n            }\n            .Name {\n              // flex: 1;\n              padding-left: 1rem;\n            }\n            .UpgradeMain {\n              flex: 1;\n              .UpgradeButton {\n                font-size: 0.75rem;\n                width: 5rem;\n                background: var(--AccentColor);\n                color: #ffffff;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border-radius: 0.313rem;\n                padding: 0.313rem;\n                gap: 0.5rem;\n                svg {\n                  // background-color: #4DCC00;\n                  // padding-left: .0000625rem;\n                }\n              }\n            }\n\n            .Status {\n              // flex: 1;\n              font-size: 0.75rem;\n              width: 7rem;\n              min-height: 1.75rem;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              background: var(--Background);\n              border-radius: 0.25rem;\n            }\n\n            .Cancel {\n              height: 1.75rem;\n              width: 1.75rem;\n\n              div {\n                width: 100%;\n                height: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                background: var(--Background);\n                border-radius: 0.25rem;\n                cursor: pointer;\n\n                svg {\n                  path {\n                    fill: var(--TextColor);\n                  }\n                }\n              }\n\n              .NotAllowed {\n                opacity: 0.2;\n                cursor: not-allowed;\n              }\n            }\n          }\n\n          .SubDetails {\n            margin-top: 0.5rem;\n            border-top: 0.0625rem solid var(--Stroke);\n            padding-top: 0.5rem;\n            display: grid;\n            grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n            gap: 1rem;\n\n            .NameStatus {\n              border: 0.0625rem solid var(--Stroke);\n              padding: 0.5rem;\n              border-radius: 0.5rem;\n              display: flex;\n              align-items: center;\n              gap: 1rem;\n\n              .LabelName {\n                flex: 1;\n                display: flex;\n                flex-direction: column;\n                gap: 0.5rem;\n                overflow: hidden;\n\n                span {\n                  color: var(--TextColor);\n                  font-size: 0.75rem;\n                  font-weight: 400;\n                }\n\n                span:nth-child(2) {\n                  font-size: 0.875rem;\n                  font-weight: 500;\n                }\n              }\n\n              .Status {\n                font-size: 0.75rem;\n                padding: 0.25rem 0.5rem;\n                border-radius: 0.25rem;\n                background: var(--Background);\n                color: var(--TextColor);\n              }\n\n              .Success,\n              .success {\n                background: var(--Completed);\n                text-transform: capitalize;\n              }\n\n              .Failed,\n              .failed {\n                background: var(--Cancelled);\n                text-transform: capitalize;\n              }\n            }\n          }\n        }\n      }\n\n      .ModalContainer {\n        position: fixed;\n        width: 100vw;\n        height: 100vh;\n        top: 0;\n        left: 0;\n        background: #6969691c;\n        backdrop-filter: blur(3px);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 2;\n\n        .Modal {\n          background: var(--Foreground);\n          padding: 2rem 2rem 1rem 2rem;\n          border-radius: 0.5rem;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 1rem;\n          width: 35rem;\n          max-height: 90%;\n          overflow: auto;\n\n          .Header {\n            font-size: 1.5rem;\n            font-weight: 700;\n            color: var(--TextColor);\n          }\n\n          .Hint {\n            width: 100%;\n            font-size: 0.875rem;\n            font-weight: 400;\n            color: var(--TextColor);\n            text-wrap: balance;\n            text-align: center;\n          }\n\n          .DropZone {\n            display: flex;\n            flex-direction: column;\n            gap: 0.75rem;\n            align-items: center;\n            width: 100%;\n            border: 0.125rem dashed var(--Stroke);\n            border-radius: 0.5rem;\n            padding: 1rem;\n\n            .Upload {\n              display: flex;\n              gap: 0.25rem;\n              font-size: 0.875rem;\n              color: var(--TextColor);\n\n              label {\n                color: var(--AccentColor);\n                font-weight: 500;\n                text-decoration: underline;\n                cursor: pointer;\n\n                input {\n                  display: none;\n                }\n              }\n            }\n          }\n\n          .DraggingOver {\n            opacity: 0.5;\n          }\n\n          textarea {\n            width: 100%;\n            padding: 0.5rem;\n            border-radius: 0.5rem;\n            height: 5rem;\n            border: 0.0625rem solid var(--Stroke);\n            background: none;\n            resize: none;\n            font-size: 0.875rem;\n            color: var(--TextColor);\n          }\n\n          .ButtonCont {\n            display: flex;\n            align-items: center;\n            flex-wrap: wrap;\n            gap: 2rem;\n\n            button {\n              width: 6rem;\n              height: 2.25rem;\n              background: var(--Background);\n              border-radius: 0.25rem;\n              font-size: 0.875rem;\n              color: var(--TextColor);\n            }\n\n            .Proceed {\n              background: var(--AccentColor);\n              color: #ffffff;\n            }\n          }\n        }\n      }\n    }\n\n  }\n\n  .UpdateToolTip {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    height: 6rem;\n    width: 24rem;\n    background: var(--Foreground);\n    border-radius: 0.5rem;\n    box-shadow: 0.125rem 0.125rem 0.5rem var(--Invitation);\n    border: 0.0625rem solid var(--AccentColor);\n\n    img {\n      height: 100%;\n      aspect-ratio: 1/1;\n      padding: 0.25rem;\n      border-radius: 0.5rem;\n    }\n\n    div {\n      width: calc(100% - 5rem);\n      display: flex;\n      flex-direction: column;\n\n      h3 {\n        font-size: 0.875rem;\n        font-weight: 700;\n        color: var(--TextColor);\n      }\n\n      p,\n      li {\n        color: var(--TextColor);\n        font-size: 0.625rem;\n      }\n\n      li {\n        margin-left: 0.5rem;\n        width: calc(100% - 1rem);\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    }\n\n    &::after,\n    &::before {\n      content: '';\n      width: 0.875rem;\n      height: 0.5rem;\n      clip-path: polygon(100% 0, 0 0, 50% 100%);\n      position: absolute;\n      background: var(--Foreground);\n      display: block;\n      // border: 0.025rem solid var(--AccentColor);\n      bottom: -0.5rem;\n      right: 0.75rem;\n    }\n\n    &::before {\n      width: 1rem;\n      height: 0.625rem;\n      background: var(--AccentColor);\n      bottom: -0.625rem;\n      right: 0.6875rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
